import { FC } from "react";
import { useTranslation } from "react-i18next";
import { FormikHelpers, useFormik } from "formik";
import { Provider } from "sdk/types";
import {
  FormContainer,
  NextButton,
  QuestionPageContainer,
} from "~/OnboardingApp/components";
import { useOnboarding } from "~/OnboardingApp/hooks/useOnboarding";
import { useSubmitOnboardingQuestion } from "~/OnboardingApp/hooks/useSubmitOnboardingQuestion";
import { OptGroupList } from "~/utils/formInputs/types";
import { GroupedSelectInput } from "./components";

type Values = {
  providerId: string;
};

export const ProviderSelectPage: FC = () => {
  const { t } = useTranslation();
  const { providerId, providers } = useOnboarding();
  const { onSubmit } = useSubmitOnboardingQuestion();

  const groupedProviders = (providers: Provider[]): OptGroupList => {
    const grouped = providers.reduce<Record<string, Provider[]>>((acc, p) => {
      (acc[p.groupingKey] = acc[p.groupingKey] || []).push(p);
      return acc;
    }, {});

    return Object.entries(grouped).map(([key, group]) => ({
      label: key,
      options: group.map((p) => ({ value: String(p.id), label: p.name })),
    }));
  };

  const initialValues: Values = {
    providerId: providerId || "",
  };

  const handleSubmit = (
    values: Values,
    formikHelpers: FormikHelpers<Values>,
  ) => {
    const { providerId } = values;

    onSubmit({ providerId }, formikHelpers);
  };

  const formik = useFormik({
    initialValues,
    onSubmit: handleSubmit,
  });
  return (
    <QuestionPageContainer>
      <FormContainer formik={formik}>
        <GroupedSelectInput
          label={t("onboarding.providerSelect.description")}
          mb={4}
          minH="unset"
          name="providerId"
          groupedOptions={groupedProviders(providers || [])}
          type="providerType"
          variant="outline-accent"
        />
        <NextButton />
      </FormContainer>
    </QuestionPageContainer>
  );
};
